import React from "react";
import { FileStack } from "lucide-react";
import { StatusBadge } from "../../StatusBadge";

const inPeriod = (isoTimestamp, period) => isoTimestamp && isoTimestamp.slice(0, 7) === period;

/** Monthly Record - Documents section (spec item 10, incremental). Reuses the contract/
 * notice records EmployeeProfilePage already fetches for the Documents tab - only the
 * events that fall inside this period are surfaced here. */
export const DocumentsSection = ({ contract, notice, period }) => {
  const events = [];
  if (contract?.employee_signature && inPeriod(contract.employee_signature.signed_at, period)) {
    events.push({ id: "contract-employee-signed", label: `Contract v${contract.version} signed by employee`, status: contract.status });
  }
  if (contract?.company_signature && inPeriod(contract.company_signature.signed_at, period)) {
    events.push({ id: "contract-company-signed", label: `Contract v${contract.version} fully executed`, status: contract.status });
  }
  if (notice?.issued_at && inPeriod(notice.issued_at, period)) {
    events.push({ id: "notice-issued", label: `Notice of Employment Conditions v${notice.version} issued`, status: notice.status });
  }
  if (notice?.acknowledged_at && inPeriod(notice.acknowledged_at, period)) {
    events.push({ id: "notice-acknowledged", label: `Notice v${notice.version} acknowledged by employee`, status: notice.status });
  }

  return (
    <div id="monthly-documents-section" className="bg-white rounded-xl border border-slate-200 p-5" data-testid="monthly-documents-section">
      <div className="flex items-center gap-2 mb-4"><FileStack size={16} className="text-slate-500" /><p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Documents</p></div>
      {events.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="monthly-documents-empty">No document event occurred during this period.</p>
      ) : (
        events.map((e) => (
          <div key={e.id} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-t-0" data-testid={`monthly-documents-event-${e.id}`}>
            <p className="text-sm text-slate-700">{e.label}</p>
            <StatusBadge status={e.status} />
          </div>
        ))
      )}
    </div>
  );
};
